export enum Constants {
    APP_READOUTS_SETMEDIASIZE = 'APP_READOUTS_SETMEDIASIZE',
    APP_READOUTS_SET_SCROLL_TOP = 'APP_READOUTS_SET_SCROLL_TOP',
    APP_READOUTS_SYSTEM_ERROR_MOUNTED = 'APP_READOUTS_SYSTEM_ERROR_MOUNTED',
    APP_READOUTS_SET_REQUEST_STATE = 'APP_READOUTS_SET_REQUEST_STATE',
    APP_READOUTS_SET_CONFIG_LOADED = 'APP_READOUTS_SET_CONFIG_LOADED',
    APP_READOUTS_SET_LANGUAGES = 'APP_READOUTS_SET_LANGUAGES',
    APP_READOUTS_HIDE_EXEMPT_POPUP = 'APP_READOUTS_HIDE_EXEMPT_POPUP',
    APP_READOUTS_SET_ORIENTATION = 'APP_READOUTS_SET_ORIENTATION',
}
